// extracted by mini-css-extract-plugin
export default {"container":"ProfileHeaderWhite_container__zvfKP","mainTitle":"ProfileHeaderWhite_mainTitle__WsMdY"};